// extracted by mini-css-extract-plugin
module.exports = {"btnCon":"scancode_btnCon__1cu5i","bgimg":"scancode_bgimg__207Nk","errortext":"scancode_errortext__3PaJb","succBtn":"scancode_succBtn__roY5F","codecon":"scancode_codecon__3Y3Js"};